import { render } from "./GeneralSurgery.vue?vue&type=template&id=7b8fb8c2&scoped=true"
import script from "./GeneralSurgery.vue?vue&type=script&lang=ts"
export * from "./GeneralSurgery.vue?vue&type=script&lang=ts"

import "./GeneralSurgery.vue?vue&type=style&index=0&id=7b8fb8c2&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-7b8fb8c2"

export default script